module.exports = {"en":{"message":{"hello":"hello world!"}}}


//////////////////
// WEBPACK FOOTER
// ./static/locales/en.json
// module id = 673
// module chunks = 8